<template>
    <div class="benefits-segmented-control" role="radiogroup" :aria-label="ariaLabel">
        <button v-for="option in options" :key="option.value" class="benefits-segmented-control-button"
            :class="{ active: value === option.value }" type="button" role="radio"
            :aria-checked="value === option.value ? 'true' : 'false'" @click="$emit('input', option.value)">
            {{ option.label }}
        </button>
    </div>
</template>

<script>
export default {
    name: "BenefitsSegmentedControl",
    model: {
        prop: "value",
        event: "input",
    },
    props: {
        value: {
            type: String,
            required: true,
        },
        options: {
            type: Array,
            required: true,
        },
        ariaLabel: {
            type: String,
            default: "",
        },
    },
};
</script>

<style lang="scss" scoped>
.benefits-segmented-control {
    align-items: stretch;
    background: #f9fafb;
    border: 1px solid #d2d6db;
    border-radius: 8px;
    box-sizing: border-box;
    display: flex;
    flex-wrap: nowrap;
    gap: 4px;
    height: 36px;
    overflow: hidden;
    padding: 2px;
    width: 100%;
}

.benefits-segmented-control-button {
    appearance: none;
    background: transparent;
    border: 0;
    border-radius: 6px;
    box-sizing: border-box;
    color: #6c737f;
    cursor: pointer;
    display: grid;
    flex: 1 1 0;
    font-family: "Inter", sans-serif;
    font-size: 14px;
    font-weight: 500;
    line-height: 1;
    margin: 0;
    min-height: 0;
    min-width: 0;
    overflow: hidden;
    padding: 0 8px;
    place-items: center;
    text-align: center;
    text-overflow: ellipsis;
    transition: background 0.15s ease, box-shadow 0.15s ease, color 0.15s ease;
    white-space: nowrap;

    &:hover,
    &:focus {
        color: #1f2a37;
        outline: none;
    }

    &:focus-visible {
        box-shadow: 0 0 0 2px rgba(56, 66, 80, 0.18);
    }

    &.active {
        background: #ffffff;
        box-shadow: 0 1px 2px rgba(16, 24, 40, 0.08);
        color: #1f2a37;
    }
}
</style>
